export const ORGANIZATION_LIST = `AllOrganizations {
  organization(order_by: {name: asc}) {
    domain
    id
    name
    created_at
    created_by_user {
      first_name
      last_name
      email
      id
    }
    organization_subscriptions_aggregate(
      where: {subscription: {deleted: {_eq: false}}}
    ) {
      aggregate {
        count
      }
    }
  }
}`;

export const ORGANIZATION_DETAIL = `OrganizationPK($id: uuid!) {
  organization_by_pk(id: $id) {
    id
    name
    organization_subscriptions(where: {subscription: {deleted: {_eq: false}}}) {
      subscription {
        name
        created_at
        created_by_user {
          first_name
          last_name
          email
          id
        }
        id
        projects_owned(where: {deleted: {_eq: false}}){
          id
          name
          new_entity_model_enabled
        }
        subscription_users(where: {created_by_user: {env_admin: {_eq: true}}}) {
          status_id
          user {
            first_name
            last_name
            email
            id
          }
        }
      }
    }
  }
}`;

export const SUBSCRIPTION_PK_DETAILS = `SubcriptionPK($subscription_id: uuid!) {
  subscription_by_pk(id: $subscription_id) {
    id
    name
    organization_subscriptions {
      organization {
        id
        name
      }
    }
    subscription_users {
      user_id
      user {
        email
        first_name
        id
        last_name
      }
    }
    projects_owned(order_by: {name: asc}) {
      id
      name
      new_entity_model_enabled
    }    
  }
}`;

export const QUERY_PROJECT_ROLES = `
  ProjectRole($where: project_role_bool_exp) {
    project_role(where: $where) {
      id
      name
      type_id
      key
    }
  }
`;

export const PROJECT_COMPANY_LIST_FOR_INVITE = `
  ProjectCompanyListForInvite($project_id: uuid!) {
    subscription_vendors(
      where: { project_vendors: { project_id: { _eq: $project_id } } }
      order_by: { name: asc }
    ) {
      id
      name
      project_vendors(where: { project_id: { _eq: $project_id } }) {
        type_id
      }
    }
  }
`;

export const QUERY_USER_SUBSCRIPTION_ROLES = `
  UserSubscriptionRole($where: subscription_permission_bool_exp = {}) {
    subscription_permission(where: $where) {
      id
      name
      key
    }
  }
`;

export const SUBSCRIPTION_LEVEL_COMPANY_LIST = `
  SubscriptionVendors($where: subscription_vendors_bool_exp = {}) {
    subscription_vendors(where: $where, order_by: { name: asc }) {
      id
      name
      address
      external_source_id
      trade_partner_pocs(where: { deleted: { _eq: false } }) {
        email
        first_name
        last_name
        phone
        id
      }
      vendor_source_infos {
        full_source_name
      }
    }
  }
`;

export const USERS_OF_SUBSCRIPTION = `subscriptionUsers($subscription_id: uuid !) {
  subscription_users(where: {subscription_id: {_eq: $subscription_id}}) {
    user_id
    status {
      name
      id
    }
    subscription_permission_id
    user {
      email
      first_name
      last_name
      id
      status {
        name
        id
      }
    }
    created_at
    created_by_user {
      email
    }
  }
}`;

export const PROJECTS_OF_SUBSCRIPTION = `subscriptionProjects($subscription_id: uuid!) {
  project(where: {owner_subscription: {id: {_eq: $subscription_id}}}) {
     id
      name
      number
      mode
      status_id
      spec_section
      details
      start_date
      end_date
      address
      created_by_user {
        email
      }
  }
}
`;

export const USER_ACTIVITIES_EVENTS = `
getAllEvents($fromDate: timestamptz!, $toDate: timestamptz!) {
audit_subscription_events(where: {_and: [{created_at: {_gte: $fromDate}}, {created_at: {_lte: $toDate}}, {subscription_id: {_is_null: false}}]}, distinct_on: event_log_id) {
    event_log {
      event {
        name
      }
    }
    created_by_user {
      email
      first_name
      last_name
    }
    subscription {
      name
      organization_subscriptions {
        organization {
          name
        }
      }
    }
    created_at
  }
  audit_project_events(where: {_and: [{created_at: {_gte: $fromDate}}, {created_at: {_lte: $toDate}}, {project_id: {_is_null: false}}]}, distinct_on: event_log_id) {
    event_log {
      event {
        name
      }
    }
    created_by_user {
      email
      first_name
      last_name
    }
    project {
      name
      owner_subscription {
        name
        organization_subscriptions {
          organization {
            name
          }
        }        
      }
    }
    created_at
  }
  audit_project_feature_events(where: {_and: [{created_at: {_gte: $fromDate}}, {created_at: {_lte: $toDate}}, {project_id: {_is_null: false}}]}, distinct_on: event_log_id) {
    event_log {
      event {
        name
      }
    }
    user_created {
      email
      first_name
      last_name
    }
    project {
      name
      owner_subscription {
        name
        organization_subscriptions {
          organization {
            name
          }
        }
      }
    }
    created_at
  }
}
`;

const FEATURE_INSTANCE_LAST_UPDATED = `
    feature_instance_last_updated(order_by: { last_updated_at: desc }, limit: 1) {
      feature_instance_id
      last_updated_at
    }
  `;

export const FEATURE_LIST_BY_FEATURE_TYPE_ID = `
  FEATURE_LIST_BY_FEATURE_TYPE_ID($where: feature_instance_bool_exp!) {
    feature_instance(where: $where) {
    id
    feature_type_id
    auto_inc_value
    title
    created_at
    created_by_user {
      email
      first_name
      last_name
    }
    updated_at
    updated_by_user {
      email
      first_name
      last_name
    }
    ${FEATURE_INSTANCE_LAST_UPDATED}
  }
}
`;

export const AUDIT_FEATURE_EVENTS_BY_WHERE = `
  AUDIT_FEATURE_EVENTS_BY_WHERE($where: audit_project_feature_events_bool_exp!) {
    audit_project_feature_events(where: $where, order_by: { created_at: desc }) {
      feature_instance_id
      field
      new_number
      new_string
      new_date
      old_date
      old_number
      old_string
      created_by
      created_at
      user_created {
        id
        first_name
        last_name
        email
      }
      event_log {
        event {
          name
        }
      }
      feature {
        name
      }
    }
  }
`;

export const FEATURE_INSTANCE_HISTORY_BY_WHERE = `
  FEATURE_INSTANCE_HISTORY_BY_WHERE($where: feature_instance_history_bool_exp!) {
    feature_instance_history(where: $where, order_by: { created_at: desc }) {
      id
      action_data
      action_description_html
      action_description
      action_type
      created_at
      feature_instance_id
      feature_type_id
      comment
      feature_instance_history_created_by_user {
        id
        first_name
        last_name
        email
      }
    }
  }
`;

export const PROJECT_USERS_BY_PROJECT = `
  PROJECT_USERS_BY_PROJECT($where: project_users_bool_exp!) {
    project_users(where: $where, order_by: { created_at: desc }) {
      id
      user_id
      project_id
      created_at
      updated_at
      external
      project_role_id
      status_id
      user {
        id
        email
        first_name
        last_name
        phone
      }
      subscription_vendor {
        id
        name
      }
      project_role {
        id
        name
      }
      status {
        id
        name
      }
      created_by_user {
        email
        first_name
        last_name
      }
      updated_by_user {
        email
        first_name
        last_name
      }
    }
  }
`;

export const AUDIT_PROJECT_USER_EVENTS = `
  AUDIT_PROJECT_USER_EVENTS($project_id: uuid!, $new_user_id: uuid!) {
    audit_project_events(
      where: {
        project_id: { _eq: $project_id }
        new_user_id: { _eq: $new_user_id }
      }
      order_by: { created_at: desc }
    ) {
      event_log_id
      field
      new_bool
      new_string
      old_bool
      old_string
      created_by
      created_at
      created_by_user {
        id
        first_name
        last_name
        email
      }
      event_log {
        source
        event {
          name
          description
        }
      }
    }
  }
`;

export const PROJECT_VENDORS_BY_PROJECT = `
  PROJECT_VENDORS_BY_PROJECT($where: project_vendors_bool_exp!) {
    project_vendors(where: $where, order_by: { id: desc }) {
      id
      project_id
      vendor_id
      vendor_name
      type_id
      status
      created_by_user {
        email
        first_name
        last_name
      }
      updated_by_user {
        email
        first_name
        last_name
      }
      updated_by
      created_by
      created_at
      updated_at
    }
  }
`;

export const AUDIT_PROJECT_VENDOR_EVENTS = `
  AUDIT_PROJECT_VENDOR_EVENTS($project_id: uuid!, $vendor_id: uuid!, $vendor_id_string: String!) {
    audit_project_events(
      where: {
        _and: [
          { project_id: { _eq: $project_id } }
          {
            _or: [
              { table_row_id: { _eq: $vendor_id } }
              {
                _and: [
                  { field: { _eq: "vendor_id" } }
                  {
                    _or: [
                      { new_string: { _eq: $vendor_id_string } }
                      { old_string: { _eq: $vendor_id_string } }
                    ]
                  }
                ]
              }
            ]
          }
          {
            event_log: {
              event: {
                name: {
                  _in: ["PROJECT_ADD_VENDOR", "PROJECT_UPDATE_VENDOR_STATUS"]
                }
              }
            }
          }
        ]
      }
      order_by: { created_at: desc }
    ) {
      event_log_id
      field
      new_bool
      new_string
      old_bool
      old_string
      created_by
      created_at
      created_by_user {
        id
        first_name
        last_name
        email
      }
      event_log {
        source
        event {
          name
          description
        }
      }
    }
  }
`;
